import NotFound from "../components/NotFound";

export default function NotFoundPage() {
  return <NotFound />;
}
